import React from 'react';
import { motion } from 'framer-motion';
import { 
  GraduationCap, 
  Building, 
  Briefcase, 
  PartyPopper, 
  Store 
} from 'lucide-react';

const SectorsSection = () => {
  const sectors = [
    {
      icon: Briefcase,
      title: 'Corporate & Office',
      description: 'Contract cleaning for commercial office environments',
    },
    {
      icon: Building,
      title: 'Healthcare',
      description: 'Compliance-ready cleaning for medical facilities',
    },
    {
      icon: GraduationCap,
      title: 'Fitness & Leisure',
      description: 'Specialist cleaning for gyms and leisure centres',
    },
    {
      icon: Store,
      title: 'Retail',
      description: 'Maintenance programmes for retail and showroom spaces',
    },
    {
      icon: PartyPopper,
      title: 'Hospitality',
      description: 'Staffing and cleaning for hotels and hospitality',
    },
  ];

  return (
    <section
      id="sectors"
      className="section-padding bg-white"
      data-testid="sectors-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <h2
            className="font-oswald text-3xl md:text-4xl lg:text-5xl font-bold text-slate-800 uppercase tracking-tight mb-4"
            data-testid="sectors-headline"
          >
            Sectors We <span className="text-accent">Support</span>
          </h2>
          <p className="font-manrope text-lg text-slate-600 max-w-2xl mx-auto">
            Tailored facility management solutions across key commercial sectors.
          </p>
        </motion.div>

        {/* Sectors Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {sectors.map((sector, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group text-center p-8 bg-slate-50 rounded-sm border border-slate-200 hover:border-accent hover:bg-white transition-all duration-300 hover:shadow-lg"
              data-testid={`sector-${index}`}
            >
              <div className="w-16 h-16 mx-auto bg-primary-light rounded-full flex items-center justify-center mb-6 group-hover:bg-accent/10 transition-colors duration-300">
                <sector.icon className="w-8 h-8 text-primary group-hover:text-accent transition-colors duration-300" />
              </div>
              <h3 className="font-oswald text-lg font-bold text-slate-800 uppercase tracking-tight mb-2">
                {sector.title}
              </h3>
              <p className="font-manrope text-sm text-slate-600">
                {sector.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SectorsSection;
